module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "p_2"
    }
  }), _vm._v(" First Mariner Books edition 2014")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 2013 by The Gronkowski Family with Jeff Schober")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data is available. ")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Gronkowski family."), _c('br'), _vm._v("\nGrowing up Gronk : a family’s story of raising champions / Gronkowski family with Jeff Schober."), _c('br'), _vm._v("\npages cm"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-12668-8 (hardback) "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-33458-8 (pbk.)"), _c('br'), _vm._v("\n1. Gronkowski, Gordon, 1959– —Family. 2. Athletes—United States—Biography. 3. Football players—United States—Biography. 4. Fathers and sons—United States—Biography. 5. Gronkowski, Chris, 1986– 6. Gronkowski, Dan, 1985– 7. Gronkowski, Rob, 1989– I. Schober, Jeff . II. Title."), _c('br'), _vm._v("\nGV697.A1G73 2013"), _c('br'), _vm._v("\n796.092'273—dc23"), _c('br'), _vm._v("\n[B]"), _c('br'), _vm._v("\n2013019374")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-12635-0"), _c('br'), _vm._v("\nv3.0814")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0